(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            container: '[data-component="Dom.Product3DModel"]',
            modelButton: '.product-3d-model-button',
            modelContent: '.product-3d-model-content',
            html: 'html',
            
        },
        data: {
            url: 'url'
        },
        classes: {
           
        },
        events: {
            click: 'click',
        },
        tpl: {
            model: '<div class="modal fade" tabindex="-1" role="dialog" id="3d-modal"><div class="modal-dialog modal-md p-lg" role="document"><div class="modal-content"><a class="btn btn-square btn-black btn-dismiss" data-dismiss="modal" aria-label="Close"></a><iframe src="{{iframeUrl}}" /></div></div></div>'
        }
    };

    ns.Product3DModel = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.Product3DModel.prototype = {
        init: function() {
            this.cacheItems();

            if (!this.html.hasClass('page-edit') && this.container.length) {
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var cache = this.settings.cache;
            
            this.modelButton = this.container.find(cache.modelButton);
            this.modelContent = this.container.find(cache.modelContent);

            this.html = $(cache.html);
           
        },
        bindEvents: function() {
            
        },
        activate: function() {
            const settings = this.settings,
                data = settings.data;

            const iframeUrl = this.modelButton.data(data.url);
            if(iframeUrl) {
                this.createModel(iframeUrl)
            }
        },

        createModel: function(iframeUrl) {
            const settings = this.settings,
                tpl = settings.tpl;

            const html = ns.fn.renderTemplate(
                {
                    iframeUrl: iframeUrl
                },
                tpl.model
            )

            this.modelContent.html(html);
        }
        
    };

    return ns;
})(window.jQuery, window.Dom || {});
